import React, { Component } from "react";
import "./index.css";
import Button from "../../../common/Button";
import P5Wrapper from "react-p5-wrapper";
import sketch from "./sketch";
export default class SampleSection extends Component {
  constructor() {
    super();
    this.state = {
      color: [Math.random() * 255, Math.random() * 255, Math.random() * 255],
      isplayed: false
    };
    this.randomColor = this.randomColor.bind(this);
  }

  randomColor() {
    this.setState({
      color: [Math.random() * 255, Math.random() * 255, Math.random() * 255]
    });
  }
  render() {
    return (
      <div id="samples"> 
        <div className="landing-header" style={{ marginTop: "10rem" }}>
          <h1>Listen Samples</h1>
        </div>

        <div
          className="waveform-section center-child no-mobo"
          style={{ minHeight: "25rem" }}
        >
          {this.state.isplayed ? (
            <P5Wrapper sketch={sketch} color={this.state.color}></P5Wrapper>
          ) : (
            <img
              src={require("../../../assets/spectromgramamps.png")}
              className="image-grad"
            />
          )}
        </div>

        <div>
          <h2 className="blue-grad center-child">help-fearful-house.wav</h2>
          <div className="center-child">
            <div
              onClick={() => {
                this.setState({
                  isplayed: true
                });
                setInterval(() => {
                  this.setState({
                    isplayed: false
                  });
                }, 4000);
              }}
            >
              <Button text={this.state.isplayed ? "stop" : "play"} />
            </div>
          </div>
        </div>
        <div className="landing-header" style={{ marginTop: "10rem" }}>
          <h1>Few More</h1>
        </div>
        <div className="sound-grid">
          <div>
            <audio controls>
              <source
                src="https://emo-speech.web.app/help-safe-fearful-20190712144602.wav"
                type="audio/wav"
              />
            </audio>
            <h3 className="blue-grad center-child">help-fearful-house.wav</h3>
          </div>
          <div>
            <audio controls>
              <source
                src="https://emo-speech.web.app/background-safe-calm-20190710150036.wav"
                type="audio/wav"
              />
            </audio>
            <h3 className="blue-grad center-child">background-calm-park.wav</h3>
          </div>
          <div>
            <audio controls>
              <source
                src="https://emo-speech.web.app/stop-safe-calm-20190710134708.wav"
                type="audio/wav"
              />
            </audio>
            <h3 className="blue-grad center-child">stop-calm-railway.wav</h3>
          </div>
        </div>
      </div>
    );
  }
}
